import { baseApi } from "./api";

export const projectCompaniesApi = baseApi.injectEndpoints({
	endpoints: (build) => ({
		// Partial, case-insensitive name search powering the "add project company"
		// typeahead so an existing company can be linked instead of duplicated.
		searchCompanies: build.query({
			query: ({ search, limit = 8 }) => ({
				url: "company/search",
				params: { search, limit },
			}),
		}),
		getProjectCompanies: build.query({
			query: (projectId) => ({
				url: `projects/${projectId}/companies`,
			}),
			providesTags: (result, _e, projectId) => [
				{ type: "ProjectCompany", id: `LIST-${projectId}` },
				...((result?.items ?? []).map((c) => ({
					type: "ProjectCompany",
					id: c.id,
				}))),
			],
		}),
		addProjectCompanies: build.mutation({
			query: ({ projectId, companyIds }) => ({
				url: `project/companies`,
				method: "POST",
				body: { projectId, companyIds },
			}),
			invalidatesTags: (_r, _e, { projectId }) => [
				{ type: "ProjectCompany", id: `LIST-${projectId}` },
			],
		}),
		createProjectCompany: build.mutation({
			// projectId is sent in the body so the API authorises the write
			// against that project (and links the new company to it).
			query: ({ projectId, ...rest }) => ({
				url: `project/company/inline`,
				method: "POST",
				body: { projectId, ...rest },
			}),
			invalidatesTags: (_r, _e, { projectId }) => [
				{ type: "ProjectCompany", id: `LIST-${projectId}` },
			],
		}),
		updateProjectCompany: build.mutation({
			// projectId is used only for tag invalidation; NOT sent in URL/body.
			query: ({ projectId: _projectId, companyId, ...body }) => ({
				url: `project/company/${companyId}`,
				method: "PUT",
				body,
			}),
			invalidatesTags: (_r, _e, { projectId, companyId }) => [
				{ type: "ProjectCompany", id: companyId },
				{ type: "ProjectCompany", id: `LIST-${projectId}` },
			],
		}),
		deleteProjectCompany: build.mutation({
			// projectId is used only for tag invalidation; NOT sent in URL.
			query: ({ projectId: _projectId, projectCompanyId }) => ({
				url: `project/company/${projectCompanyId}`,
				method: "DELETE",
			}),
			invalidatesTags: (_r, _e, { projectId, projectCompanyId }) => [
				{ type: "ProjectCompany", id: projectCompanyId },
				{ type: "ProjectCompany", id: `LIST-${projectId}` },
			],
		}),
	}),
});

export const {
	useGetProjectCompaniesQuery,
	useLazySearchCompaniesQuery,
	useAddProjectCompaniesMutation,
	useCreateProjectCompanyMutation,
	useUpdateProjectCompanyMutation,
	useDeleteProjectCompanyMutation,
} = projectCompaniesApi;
